import {
  Datagrid,
  DateField,
  List,
  NumberField,
  SearchInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { EMOTION_LEVELS, EMOTION_TYPES } from "../constants/emotions";
import { useCommonLabels, useFieldLabels } from "../i18n/hooks";

const filters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <SelectInput key="type" source="Type" choices={EMOTION_TYPES} />,
  <SelectInput key="level" source="Level" choices={EMOTION_LEVELS} />,
];

export const PhEmotionsList = () => {
  const c = useCommonLabels();
  const f = useFieldLabels();
  return (
    <List filters={filters} sort={{ field: "CreatedAt", order: "DESC" }} perPage={25}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="Type" label={c.type} />
        <NumberField source="Level" label={c.level} />
        <NumberField source="UserId" label={c.userId} />
        <DateField source="CreatedAt" label={c.createdAt} showTime />
        <TextField source="Description" label={f.descriptionRu} />
      </Datagrid>
    </List>
  );
};

export const PhEmotionsShow = () => {
  const c = useCommonLabels();
  const f = useFieldLabels();
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="Id" label="ID" />
        <TextField source="Type" label={c.type} />
        <NumberField source="Level" label={c.level} />
        <NumberField source="UserId" label={c.userId} />
        <DateField source="CreatedAt" label={c.createdAt} showTime />
        <TextField source="Description" label={f.descriptionRu} />
        <TextField source="EmotionInsight" label={f.emotionInsight} />
        <TextField source="PreventionPlan" label={f.preventionPlan} />
        <TextField source="AlternativeResponse" label={f.alternativeResponse} />
      </SimpleShowLayout>
    </Show>
  );
};
